<template>
    <!--合作伙伴-->
    <div class="partner">
        <div class="partner_img">
            <div class="imgList_pc">
                <div class="imgItem" :class="{'active': item.id == accountActive1}"
                     v-for="(item, index) in picList.slice(0, 8)" :key="index">
                    <img :src="item.img">
                </div>
            </div>

            <div class="imgList_app">
                <div class="imgItem" :class="{'active': item.id == accountActive2}"
                     v-for="(item, index) in picList.slice(0, 2)" :key="index">
                    <img :src="item.img">
                </div>
            </div>

            <div class="handleright" @click="handleSwitch(1)">
                <img src="@/asstes/home/partner/left.png" style="width: 48px; height: 48px;">
            </div>

        </div>
    </div>

</template>

<script>
    export default {
        data(){
            return{
                accountActive1: 5,
                accountActive2: 1,
                picList:[
                    {
                        id: 1,
                        img: require('@/asstes/home/partner/first.png')
                    },
                    {
                        id: 2,
                        img: require('@/asstes/home/partner/second.png')
                    },
                    {
                        id: 3,
                        img: require('@/asstes/home/partner/third.png')
                    },
                    {
                        id: 4,
                        img: require('@/asstes/home/partner/fourth.png')
                    },
                    {
                        id: 5,
                        img: require('@/asstes/home/partner/fifth.png')
                    },
                    {
                        id: 6,
                        img: require('@/asstes/home/partner/sixth.png')
                    },
                    {
                        id: 7,
                        img: require('@/asstes/home/partner/seventh.png')
                    },
                    {
                        id: 8,
                        img: require('@/asstes/home/partner/eighth.png')
                    },
                ],
                screenWidth: ''
            }
        },
        watch:{
            screenWidth(val){
                // console.log(val)
                if( val <= 580 ){
                    this.accountActive = 1
                }else {
                    this.accountActive = 5
                }
            }
        },
        mounted() {
            window.onresize = () => {
                return (() => {
                    this.screenWidth = document.body.clientWidth;
                })();
            };
        },
        methods:{
            handleSwitch(p){
                let that = this;
                that.picList = that.picList.map( (item, index, array ) => {
                    if(index === array.length - 1 && p === 1){
                        item = array[0];
                    }
                    else if(index === 0 && p === -1){
                        item = array[array.length-1];

                    }else{
                        item = array[index+p];
                    }
                    return item;
                })
                that.accountActive1 = that.picList[4].id;
                that.accountActive2 = that.picList[0].id;
            }
        }
    }
</script>

<style lang="less" scoped>

    .active {
        border-radius: 10px;
        border: 2px solid #E7E5E5;
    }

    @media only screen and (max-width: 750px) {
        .partner{
            width: 100%;
            .partner_img{
                display: flex;
                align-items: center;
                justify-content: center;

                .imgList_pc{
                    display: none;
                }

                .imgList_app{
                    display: flex;
                    align-items: center;

                    .imgItem{
                        margin: 0 64px;
                        width: 288px;
                        height: 288px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        overflow: hidden;
                        img{
                            width: 288px;
                            height: 288px;
                        }
                    }
                    .active {
                        border-radius: 10px;
                        border: 2px solid #E7E5E5;
                    }
                }
                .handleright{
                    padding: 0 64px;
                    box-sizing: border-box;
                }
            }
        }
    }

    @media only screen and (min-width: 750px) {
        .partner {
            text-align: center;
            color: #353856;

            .partner_img {
                display: flex;
                justify-content: space-between;
                align-items: center;

                .imgList_pc {
                    width: 900px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    overflow: hidden;

                    .imgItem {
                        width: 80px;
                        height: 80px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        overflow: hidden;
                        img{
                            width: 80px;
                            height: 80px;
                        }
                    }
                    .active {
                        border-radius: 10px;
                        border: 2px solid #E7E5E5;
                    }
                }
                .imgList_app{
                    display: none;
                }

                .handleright {
                    width: calc(100% - 900px);
                }

                .handleright:hover {
                    cursor: pointer;
                }
            }
        }
    }
</style>
